import ShuttleAppreciation from '../../shuttle_software/ShuttleAppreciation';
import UberBanner from './UberBanner'
import { lazy, Suspense } from 'react'

const UberService = lazy(() => import('./UberService'));
const UberSliderApp = lazy(() => import('./UberSliderApp'));
const UberDisclaimer = lazy(() => import('./UberDisclaimer'));
const UberSuccess = lazy(() => import('./UberSuccess'));
const UberShift = lazy(() => import('./UberShift'));
const UberWheel = lazy(() => import('./UberWheel'));
const UberFaqs = lazy(() => import('./UberFaqs'));
const OnDemandWork = lazy(() => import("../onDemand/OnDemandWork"));

export default function UberClone() {
  return (
    <>
      <UberBanner />

      <Suspense fallback={null}>
        <UberService />
        <UberSliderApp />
        <UberSuccess />
        <UberShift />
        <UberWheel />
        <div className="solution-case">
          <OnDemandWork />
        </div>
        <div className="uber-testimonial">
          <ShuttleAppreciation/>
        </div>
        <UberFaqs />
        <UberDisclaimer />
      </Suspense>
    </>
  )
}
